import React, { useCallback } from 'react';

import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import SearchAutoItem from '@wconcept/wconcept-ui-renewal/components/molecules/_item/SearchAutoItem';

import * as S from './style';
// import { SearchAutoCompleteContent } from '@models/search';
// import {
//   sendTagSearchInitOnClickAutoSearchBrand,
//   sendTagSearchInitPageOnClickAutoSearchItem,
// } from '@tags/amplitudes/searchPageTags';

export interface Keyword {
  highlight: string;
  keyword: string;
  searchType: string;
}

export interface Brand {
  brandCd: string;
  brandNameEn: string;
  brandNameKr: string;
  keyword: string;
  webViewUrl: string;
  tags?: string[];
}

export interface SearchAutoCompleteContent {
  total: number;
  keywordList: Keyword[];
  brandList: Brand[];
}

interface IProps {
  /** isDesktop */
  isDesktop: boolean;
  /** isNativeAppBoth */
  isNativeAppBoth: boolean;
  /** keyword */
  keyword?: string;
  /** searchResults */
  searchResults?: SearchAutoCompleteContent;
  /** onClick */
  onClick?: (
    value: string,
    url: string,
    type: string,
    v?: Brand,
    no?: number
  ) => void;
  /** onClose */
  onClose?: () => void;
}

const SchAutoListDesktop = ({
  isDesktop,
  isNativeAppBoth,
  keyword,
  searchResults,
  onClick,
  onClose,
}: IProps) => {
  // const [_keyword, setKeyword] = useState('');
  // const [searchResults, setSearchResults] = useState<any>({});
  // const [_searchResults, setSearchResults] = useState<any>(searchResults);

  //= ================== ITEM HANDLER ======================

  // ITEM HANDLER : onClickItem
  const onClickItem = useCallback(
    (
      targetKeyword: string,
      url: string,
      type: string,
      v?: Brand,
      no?: number
    ) => {
      if (onClick) {
        onClick(targetKeyword, url, type, v, no);
      }
    },
    [onClick]
  );

  //= ================== ITEM RENDERER ======================

  // ITEM RENDERER : getBrandItems
  const getBrandItems = useCallback(() => {
    if (searchResults && searchResults?.brandList.length > 0) {
      return (
        <ul className="auto-brand">
          {searchResults.brandList?.map((v, i: number) => {
            const exclusiveTag = v?.tags?.find(x => x === '단독');
            return (
              <SearchAutoItem
                key={v.brandCd}
                type="brand"
                keyword={keyword}
                name={v.brandNameKr}
                nameEn={v.brandNameEn}
                exclusive={exclusiveTag === '단독'}
                onClick={() => {
                  // sendTagSearchInitOnClickAutoSearchBrand(
                  //   isDesktop,
                  //   isNativeAppBoth,
                  //   String(domainGenderType).toLowerCase(),
                  //   keyword || '',
                  //   v,
                  //   i
                  // );
                  onClickItem(v.keyword, v.brandCd, 'brand', v, i + 1);
                }}
              />
            );
          })}
        </ul>
      );
    }
    return null;
  }, [keyword, onClickItem, searchResults]);

  // ITEM RENDERER : getKeywordItems
  const getKeywordItems = useCallback(() => {
    if (searchResults && searchResults.keywordList.length > 0) {
      return (
        <ul className="auto-keyword">
          {searchResults.keywordList?.map((v: Keyword, i: number) => (
            <SearchAutoItem
              key={v.keyword}
              type="common"
              keyword={keyword}
              name={v.highlight}
              onClick={() => {
                // sendTagSearchInitPageOnClickAutoSearchItem(
                //   isDesktop,
                //   isNativeAppBoth,
                //   String(domainGenderType).toLowerCase(),
                //   keyword || '',
                //   v,
                //   i
                // );
                onClickItem(v.keyword, v.keyword, 'keyword', undefined, i + 1);
              }}
            />
          ))}
        </ul>
      );
    }
    return null;
  }, [keyword, onClickItem, searchResults]);

  return (
    <S.SchAutoListDesktop className="sch-autolist-desktop">
      <div className="area-list">
        {getBrandItems()}
        {getKeywordItems()}
      </div>
      <div className="bottom">
        <Button onClick={onClose}>닫기</Button>
      </div>
    </S.SchAutoListDesktop>
  );
};

export default SchAutoListDesktop;
